import will from './will.svg'
import memorial from './memorial.svg'

export {
  will,
  memorial
}
